<template>
    <div class="container">
        <div class="agent-register-complete">
            <h1 class="page_h1">密碼已重設</h1>
            <div class="form f-row">
                <div class="register_step">
                    <h4 class="register_title">完成</h4>
                    <p class="register_txt">已修改完畢，請重新登入</p>
                </div>
                <div class="form_grp f-col@lg:auto align:r mg-t-12">
                    <button class="btn w:full clr:primary" @click="onClick">前往登入</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import formInupt from '../../../components/form/input.vue'
    import {mapGetters, mapState} from "vuex";

    export default {
        name: 'reset-complete',
        components: {
            formInupt,
        },
        mounted() {
            const vm = this
            if (!vm.$route.params.hasOwnProperty('created')) {
                window.location = '/'
            }
        },
        beforeRouteEnter(to, from, next) {
            // 在渲染该组件的对应路由被 confirm 前调用
            // 不！能！获取组件实例 `this`
            // 因为当守卫执行前，组件实例还没被创建
            if (!to.params.hasOwnProperty('created')) {
                window.location = '/'
                return
            }
            next()
        },
        methods: {
            onClick() {
                window.location = '/'
            }
        },
    }
</script>

<style lang="scss" scoped>
    .router_link {
        font-size: 0.875rem;
    }

    .reset-mg\:b {
        margin-bottom: 0.75rem;
    }
</style>
